<template>
  <div class="integral">
    <div class="main">
      <div class="top">
        <div class="total-score">
          <h2>
            <span>{{ remain }}</span>
            积分
          </h2>
          <p @click="goRecord(1)">我的积分记录 ></p>
        </div>
        <div class="sign-in">
          <p>
            已连续签到
            <span>{{ signInDay }}/7天</span>
            <em>
              连续签到可以获得
              <span>更多积分~</span>
            </em>
          </p>
          <ul>
            <li v-for="(item, index) in signIn" :key="index">
              <span :class="item.already ? 'already' : ''">{{ item.num }}</span>
              <p>第{{ item.day }}天</p>
            </li>
          </ul>
          <button
            :disabled="disabled"
            class="btn"
            @click="signInFun()"
          ></button>
        </div>
      </div>
      <!-- v-if="activityList.length > 0 " -->
      <div class="smoke-prize" >
        <h2>
          任务奖励
          <span @click="goRecord(2)">我的获奖记录</span>
        </h2>
        <ul>
          <li
            v-for="(item, index) in activityList"
            :key="index"
            :class="
              item.activityType == '0001' ? 'new-activity' : 'integral-activity'
            "
          >
         
        
            <em v-if="item.activityType == '0001'">
              已有{{ item.partake }}人领取福利
            </em>
            <span
           
              :class="item.isPart ? 'disabled' : ''"
              @click="
                extract(item.isPart, item.activityType, item.id, item.consume)
              "
            >
              去抽奖
            </span>
            <dl>
              <dt>
                <img
                  v-if="item.activityType == '0001'"
                  src="@/assets/img/integral_img1.png"
                />
                <img v-else src="@/assets/img/integral_img2.png" />
              </dt>
              <dd>
                <h3>{{ item.name }}</h3>
                <p>
                  {{ item.description }}
                </p>
              </dd>
            </dl>
          
          </li>
        </ul>
        <div></div>
      </div>
      <div class="integral-trends">
        <h2>积分抽奖最新动态</h2>
        <div class="list">
          <vue-seamless-scroll :data="trends" :class-option="optionSetting">
            <ul>
              <li v-for="(item, index) in trends" :key="index">
                <p>{{ item.name }}</p>
                <span>获得{{ item.money }}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <extract-turntable
      :type="type"
      :turntable-data="turntableData"
      :activity-id="activityId"
      ref="ExtractTurntableRef"
    />
  </div>
</template>
<script>
import ExtractTurntable from './components/ExtractTurntable'
import vueSeamlessScroll from 'vue-seamless-scroll'
import {
  getAppintegral,
  integralSignIn,
  getActivityDetail,
  getWinners
} from '@/api/activity'
import Cookies from 'js-cookie'
export default {
  name: 'Integral',
  components: {
    ExtractTurntable,
    vueSeamlessScroll,
  },
  data() {
    return {
      signIn: [
        {
          already: true,
          num: 30,
          day: 1,
        },
        {
          already: true,
          num: 60,
          day: 2,
        },
        {
          already: false,
          num: 60,
          day: 3,
        },
        {
          already: false,
          num: 60,
          day: 4,
        },
        {
          already: false,
          num: 60,
          day: 5,
        },
        {
          already: false,
          num: 60,
          day: 6,
        },
        {
          already: false,
          num: 60,
          day: 7,
        },
      ],
      trends: [],
      disabled: false,
      signInDay: 0,
      type: '0001',
      turntableData: [],
      userCode: '',
      remain: 0,
      activityList: [],
      activityId: '',
    }
  },
  computed: {
    optionSetting() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 49, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停
        stopdirection: 1, // 0向下 1向上 2向左 3向右
        autoplay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction =>0/1
        singlewidth: 0, // 单步运动停止的宽度(默认值e是无缝不停止的滚动) direction =>2/3
        waitTime: 1000, // 单步运动停止的时间(认值1000ms)
        openTouch:false
      }
    },
  },
  mounted() {
    document.title = '积分中心'
    this.userCode = this.$route.query.userCode
    this.init()
  },
  methods: {
    async init() {
      let data = {}
      let res = await getAppintegral(data)
      if (res.code == '1000') {
        this.getTrends()
        this.remain = res.data.remain ? res.data.remain : 0
        this.signInDay = res.data.userOperEntites
          ? res.data.userOperEntites.length
          : 0
        this.activityList = res.data.activityResps
        res.data.integrals.forEach((item, index) => {
          this.signIn[index].num = item
          this.signIn[index].day = index + 1
          this.signIn[index].already =
            res.data.userOperEntites && index < res.data.userOperEntites.length
              ? true
              : false
        })
      }
    },
    async getTrends() {
      let data = {}
      let res = await getWinners(data)
      if (res.code == '1000') {
        this.trends = res.data
      }
    },
    async signInFun() {
      let data = {}
      let res = await integralSignIn(data)
      if (res.code == '1000') {
        // this.disabled = true
        this.$message({message:'签到成功', type:'success'})
        this.init()
      } else if (res.code == '9999') {
        this.$message({message: res.msg, type: 'warning'})
      }
    },
    async extract(state, type, id, consume) {
      if (state) return
      if (consume > this.remain) {
        this.$message({message: '积分不足', type: 'warning'})
        return
      }
      let res = await getActivityDetail(id)
      if (res.code == '1000') {
        this.turntableData = res.data.list
      }
      this.$refs.ExtractTurntableRef.showExtract = true
      this.$refs.ExtractTurntableRef.userCode = this.userCode
      this.type = type
      this.activityId = id
    },
    goRecord(type) {
      if (type == 1) {
        this.$router.push({
          path: '/integralRecord',
          query: { userCode: this.userCode },
        })
      } else {
        this.$router.push({
          path: '/awardRecord',
          query: { userCode: this.userCode },
        })
      }
    }
  },
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.integral {
  width: 100%;
  height: 100%;
  background: #f2f5fa;
  display: flex;
  flex-direction: column;
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: auto;
  }
  .top {
    background-image: linear-gradient(to bottom, #2cca92, #f2f5fa);
    padding: 8px 15px;
    // height: 61.85vh;
    height: 350px;
    .total-score {
      width: 310px;
      height: 143px;
      margin: 0 auto;
      background: url('~@/assets/img/integral_bg.png') center center no-repeat;
      background-size: 100%;
      padding-top: 10px;
      h2 {
        color: #e54c50;
        font-weight: 500;
        font-size: 15px;
        margin: 0 auto;
        text-align: center;
        span {
          font-weight: 600;
          font-size: 45px;
          color: #e54c50;
        }
      }
      p {
        margin: 0 auto;
        width: 132px;
        height:20px;
        background: #f7d6ac;
        border-radius: 10px;
        text-align: center;
        color: #b43e38;
        line-height:20px;
        font-size: 14px;
      }
    }
    .sign-in {
      width: 100%;
      height: 165px;
      background: #ffffff;
      border-radius: 10px;
      margin-top: -4.3vh;
      padding: 9px 10px;
      p {
        font-size: 15px;
        color: #333;
        em {
          float: right;
          color: #999999;
          font-size: 15px;
          // margin-top: 10px;
          span {
            font-size: 15px;
          }
        }
      }
      span {
        color: #f77b0f;
      }
      ul {
        height: 58px;
        margin-top: 20px;
      }
      li {
        width: 42.5px;
        height: 59px;
        background: linear-gradient(-5deg, #fbedc2, #fcf7dc);
        border: 2px solid #f3b061;
        border-radius: 10px;
        // display: inline-block;
        float: left;
        margin-right: 3px;
        overflow: hidden;
        padding-top: 8px;
        &:nth-of-type(7) {
          margin-right: 0;
        }
        span {
          width: 24px;
          height: 24px;
          display: block;
          margin: 0 auto;
          background: url('~@/assets/img/integral_sign_not.png') center center
            no-repeat;
          background-size: 100%;
          text-align: center;
          line-height: 24px;
          color: #fff;
          font-size: 14px;
        }
        .already {
          background: url('~@/assets/img/integral_sign_already.png') center
            center no-repeat;
          background-size: 100%;
          color: #a9a9a9;
        }
        p {
          margin-top: 6px;
          text-align: center;
          font-size: 12px;
          color: #b16c38;
        }
      }
      .btn {
        width: 217px;
        height: 57px;
        background: url('~@/assets/img/sign_btn.png') center no-repeat;
        background-size: 100%;
        margin: 20px auto;
        border: none;
        display: block;
      }
    }
  }
  .smoke-prize {
    width: 345px;
    height: auto;
    background: #ffffff;
    border-radius: 3.38vw;
    margin: -20px auto 5px;
    padding: 15px 15px;
    h2 {
      font-size: 18px;
      font-style: italic;
      color: #333333;
      margin-bottom: 15px;
      position: relative;
      &::after {
        content: '';
        display: inline-block;
        background: url('~@/assets/img/integral_icon.png') no-repeat;
        background-size: 100% 100%;
        vertical-align: middle;
        margin: -10px 0 0 12px;
        width: 25px;
        height: 25px;
      }
      span {
        position: absolute;
        right: 8px;
        top: 0;
        font-size: 15px;
        color: #b43e38;
        font-style: normal;
        font-weight: 400;
      }
    }
    li {
      width: 100%;
      height: 80px;
      border-radius: 5px;
      margin-bottom: 15px;
      background: #fefaeb;
      border: 2px solid #f7d46d;
      position: relative;
      padding: 20px 0 0 15px;
      em {
        position: absolute;
        left: -1px;
        top: -1px;
        background: #fb4933;
        border-radius: 16px 0 18px 0;
        text-align: center;
        width: 128px;
        height: 16px;
        line-height:16px;
        font-size: 9px;
        color: #fff;
      }
      span {
        width: 68px;
        height: 27px;
        background: linear-gradient(267deg, #ff323c, #fe6859);
        border: 2px solid #fbe06e;
        box-shadow: 0px 3px 0px 0px rgba(109, 90, 17, 0.19);
        border-radius: 10px;
        text-align: center;
        line-height: 25px;
        font-size: 10px;
        color: #fff;
        position: absolute;
        top: 30px;
        right: 15px;
      }
      .disabled {
        background: linear-gradient(267deg, #ccc, #ccc);
        border: 2px solid #efefef;
        box-shadow: 0px 3px 0px 0px rgba(109, 90, 17, 0.19);
        color: #666;
      }
      dl {
        width: 100%;
        height: 100%;
        dt {
          float: left;
          width: 34px;
          img {
            width: 100%;
          }
        }
        dd {
          float: left;
          margin-left: 5px;
          width: 120px;
          h3 {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }
          p {
            margin-top: 5px;
            color: #999999;
            font-size: 13px;
            line-height: 13px;
            overflow: hidden;
            height: 13px;
          }
        }
      }
    }
    .new-activity {
      dl {
        padding-top: 5px;
      }
    }
    .integral-activity {
      padding: 10px 15px !important;
      dd {
        margin-top: 7.5px;
      }
      span {
        top: 28px;
      }
    }
  }
  .integral-trends {
    width: 91.91vw;
    height: auto;
    background: #ffffff;
    border-radius: 3.38vw;
    padding: 3vh 0;
    margin: 0 auto 7.5vh;
    h2 {
      font-size: 5.42vw;
      font-style: italic;
      color: #333333;
      padding: 0 3.9vw 2.55vh 4.55vw;
      border-bottom: 2px solid #ededed;
    }
    .list {
      width: 100%;
      height: 66vh;
      overflow: hidden;
    }
    li {
      width: 100%;
      height: 7.35vh;
      line-height: 7.35vh;
      border-bottom: 1px solid #ededed;
      padding: 0 3.9vw 0 4.55vw;
      position: relative;
      p {
        color: #666666;
        font-size: 3.64vw;
        &::before {
          content: '';
          display: inline-block;
          vertical-align: middle;
          margin: -0.5vh 2.99vw 0 0;
          width: 2.08vw;
          height: 2.08vw;
          background: #22c089;
          border-radius: 50%;
        }
      }
      span {
        position: absolute;
        right: 3.9vw;
        top: 0;
        color: #333333;
        font-size: 3.64vw;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/integral.vue